import React, { FC, useState, useEffect, useRef } from 'react';
import { VideoPlayerProps } from './index.types';

const VideoPlayer: FC<VideoPlayerProps> = ({ link, width, height, title = "", className = "", playCallback, pauseCallback }) => {
  const [youtubeVideoID, setYoutubeVideoID] = useState("");
  const VideoTagRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    function playEventHandler(event) {
      if (playCallback) {
        playCallback(event);
      }
    }
    function pauseEventHandler(event) {
      if (pauseCallback) {
        pauseCallback(event);
      }
    }
    if (VideoTagRef && VideoTagRef.current) {
      (VideoTagRef.current as HTMLElement).addEventListener("playing", playEventHandler);
      (VideoTagRef.current as HTMLElement).addEventListener("pause", pauseEventHandler);
    }
    return () => {
      if (VideoTagRef && VideoTagRef.current) {
        (VideoTagRef.current as HTMLElement).removeEventListener("playing", playEventHandler);
        (VideoTagRef.current as HTMLElement).removeEventListener("pause", pauseEventHandler);
      }
    }
  }, [VideoTagRef, playCallback, pauseCallback]);

  useEffect(() => {
    if (!link) return;
    let video_id = "";
    if (link.includes("youtube")) {
      if (link.includes('watch')) {
        video_id = link.split('v=')[1];
        let ampPos = video_id.indexOf('&');
        if (ampPos != -1) {
          video_id = video_id.substring(0, ampPos);
        }
      } else if (link.includes('embed')) {
        video_id = link.split("embed/")[1];
        let quesPos = video_id.indexOf('?');
        if (quesPos != -1) {
          video_id = video_id.substring(0, quesPos);
        }
      }
    } else if (link.includes("youtu.be")) {
      video_id = link.split("youtu.be/")[1];
    }
    if (video_id) {
      setYoutubeVideoID(video_id);
    }
  }, [link])

  return (
    < >
      {youtubeVideoID ?
        <iframe
          src={`https://www.youtube.com/embed/${youtubeVideoID}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          width={width}
          title={title}
          height={height}
          className={`${className} ${className + "__youtube-video"}`}
        ></iframe> :
        <video ref={VideoTagRef} src={link} controls className={`${className} ${className + "__internal-video"}`} />
      }
    </>
  )
}
export default VideoPlayer;